/**
 * log to cat
 * */

var request = require("./request");
var config = require('./config');

var logCache = {}
var errorCache = {}

module.exports = function (startTime, type, isSuccess) {
    var source = config.get('source');

    var tuAll = "whereami-type-all";
    var tuType = "whereami-type-" + type;
    if (source) {
        tuAll += ('-'+source);
        tuType += ('-'+source);
    }
    /**
     * cat 监控
     * http://cat.dianpingoa.com/cat/r/web?domain=cat&ip=All&date=2015080314&reportType=view&op=view
     * whereami开头的分类中
     * */
    var catData = {
        v: 1,
        ts: +new Date(),
        tu: tuAll,
        d: (+new Date() - startTime),
        hs: isSuccess ? 200 : 500,
        ec: ""
    };

    if (!logCache[tuType] && Math.random() > config.get('sampling')) {
        //每个页面每种类型只发送一次统计
        logCache[tuType] = true
        //发送all 和 指定type的
        send(catData);

        catData.tu = tuType;

        send(catData);
    }
};

var send = function (catData) {
    var catDataStr = [];
    for (var o in catData) {
        if (catData.hasOwnProperty(o)) {
            catDataStr.push(o + "=" + catData[o]);
        }
    }
    var img = new Image();
    img.src = "//catdot.dianping.com/broker-service/api/single?" + catDataStr.join("&");
};

/**
 * 手机详细错误日志，打到cat Event中
 * */
module.exports.logError = function (geoType, info) {
    if (errorCache[geoType]) return;
    
    //  同一个页面同一类型只记录一次错误
    errorCache[geoType] = true;

    var host = (~location.href.indexOf("51ping.com") || ~location.href.indexOf("test.meituan.com")) ? "m.51ping.com" : "m.dianping.com";
    request({
        url: "//" + host + "/statictest/logevent",
        data: {
            name: "WhereAmIFail",
            info: encodeURIComponent(geoType + "-" + info)
        }
    });

    //no support UA
    if(~info.indexOf("no geo support")){
        request({
            url: "//" + host + "/statictest/logevent",
            data: {
                name: "WhereAmIFailUA",
                info: navigator.userAgent
            }
        });
    }

};


// WEBPACK FOOTER //
// ./~/@dp/whereami/lib/log.js